<template lang="pug">
.d-contents
  .list.text-body-1
    p.mb-4 Для продолжения использования сервиса, заполните свой профиль
  user-requirements-form(
    :fields="fields"
    @update="onUpdateProfile"
  )
    template(#save-btn="{ action, loading, disabled }")
      portal(
        :to="`${constants.DIALOG_PORTAL_KEY}.actions`"
        v-slot="{ close }"
      )
        .d-flex.justify-center.gap-16.full-width
          app-button(
            rounded
            outlined
            large
            @click="close"
          ) Закрыть
          app-button(
            :loading="loading"
            :disabled="disabled"
            rounded
            large
            @click="action"
          ) Сохранить
</template>

<script>
import UserRequirementsForm from '@/components/forms/UserRequirementsForm.vue';
import { DIALOG_PORTAL_KEY } from '../constants';

export default {
  name: 'MemberWelcome',
  components: {
    UserRequirementsForm,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    constants() {
      return {
        DIALOG_PORTAL_KEY,
      };
    },
    fields() {
      return {
        region: { required: !this.$user?.profile?.region?.id || !this.$user?.profile?.municipality?.id },
        municipality: { required: !this.$user?.profile?.municipality?.id || !this.$user?.profile?.region?.id },
        first_name: { required: !this.$user?.profile?.first_name },
        last_name: { required: !this.$user?.profile?.last_name },
        birthday_at: { required: !this.$user?.profile?.birthday_at },
        snils: { required: !this.$user?.profile?.snils },
      };
    },
    needUpdateProfile() {
      return Object.values(this.fields).some(Boolean);
    },
  },
  watch: {},
  created() {
    if (!this.needUpdateProfile) {
      this.closeDialog();
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    onUpdateProfile() {
      this.closeDialog();
    },
  },
};
</script>
